module.exports = __webpack_public_path__ + "img/kiki_logo_main.aab6fcaf.png";